export default __webpack_public_path__ + "static/CoinGecko-16ec6c267f858f9bdef1b8cb623547c3.svg";